import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgInt } from '../../custom-types/fg-integer.js';

const floatToIntDef = {
  type: FgBlockType.FloatToInt,
  build: () => ({
    dataIn: [sockIn("a", FgType.Number, 0)],
    dataOut: [sockOut("value", FgType.Integer)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    const mode = block.config?.roundingMode;
    const r = mode === "floor" ? Math.floor(a) : mode === "ceil" ? Math.ceil(a) : mode === "round" ? Math.round(a) : Math.trunc(a);
    setDataValue(ctx, block, "value", fgInt(r));
  }
};

export { floatToIntDef };
//# sourceMappingURL=float-to-int.js.map
